import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { routes, enums, acoes, LANCAMENTO_PAGO } from '../../../constants'
import storage from '../../../services/stoage.service'
import utils from '../../../utils'
import { actions } from '../livrocaixa.actions'
import { LivroCaixaForm } from './LivroCaixaForm'
import { Button } from 'primereact/button'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import * as listPageUtils from '../../../utils/listPageContainerUtils'
import { AgendarTelaFixa } from '../../../components/agendamentoRelatorio/AgendarTelaFixa'
import { logarAcesso } from '../../../services/api-log-acesso'
import { nomeRelatorio } from '../../../components/agendamentoRelatorio/textos'

const mapStateToProps = (state) => {
  const messages = state.crudLivroCaixaState.messages
  const record = state.crudLivroCaixaState.currentRecord

  // REFERENTE AO DROPDOWN DE UNIDADES
  let disableUnit = false
  let currentUnit = storage.getUnit()
  if (currentUnit) {
    let unidade = {
      id: currentUnit.oid,
      value: currentUnit.sigla,
    }
    Object.assign(record, { unidades: [unidade] })
    Object.assign(record, { unidade: [unidade] })
    disableUnit = true
  }

  let unidades = []
  let unidadesEmpresa = utils.getListIdValuesUnidadeFromEmpresa(storage.getCompany())
  unidades = unidades.concat(unidadesEmpresa)

  const configFormasPagamento = utils.getConfiguracaoFormasPagamento(storage.getCompany(), null)
  //-- status LANCAMENTO_PAGO para forcar carregar todas as formas de pagto Stone --//
  const formasPagamento = utils.getFormasPagamento(enums.FormasPagamento, configFormasPagamento, LANCAMENTO_PAGO)
  const filtraUsuarioBaixa = storage.getAcao(acoes.CAIXA_USUARIO)
  return {
    record,
    messages,
    unidades,
    disableUnit,
    formasPagamento,
    filtraUsuarioBaixa,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.setType(null))
      dispatch(actions.applyFilter(filterParams))
    },
    setField: (field, value) => dispatch(actions.setField(field, value)),
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let valor = target.value
      if (field === 'isDetalhado' || field === 'hasTotalizadores') {
        valor = target.checked
      }
      dispatch(actions.removeErrors([{ field }]))

      dispatch(actions.setField(field, valor))
    },
    onClickBotaoDinamico: (listId, oidBotao) => dispatch(actions.executarFuncaoDinamica(listId, oidBotao)),
    saveHandler: (event) => dispatch(actions.save()),
    removeHandler: (event) => dispatch(actions.remove()),
    newHandler: (event) => dispatch(actions.makeNew()),
    loadById: (oid) => dispatch(actions.loadById(oid)),
    loadFavorito: (menu) => dispatch(actions.loadFavorito(menu)),
    removeFavorito: (menu) => dispatch(actions.removeFavorito(menu)),
    adicionarFavorito: (menu) => dispatch(actions.adicionarFavorito(menu)),
    carregarTiposSepulturas: (unidade) => dispatch(actions.carregarTiposSepulturas(unidade)),
    carregarContasCorrentes: (unidade) => dispatch(actions.carregarContasCorrentes(unidade)),
    carregarUsuariosBaixa: (unidade) => dispatch(actions.carregarUsuariosBaixa(unidade)),
    getBotoesDinamicos: (idTela) => {
      let tipoTela = Number(enums.TipoTela.FORMULARIO)
      dispatch(actions.getBotoesDinamicos(idTela, tipoTela))
    },
    abrirRelatorio: (
      dataInicial,
      dataFinal,
      unidade,
      isDetalhado,
      hasTotalizadores,
      formasPagamento,
      tiposSepulturas,
      usuariosBaixa,
      contas
    ) =>
      dispatch(
        actions.abrirRelatorio(
          dataInicial,
          dataFinal,
          unidade,
          isDetalhado,
          hasTotalizadores,
          formasPagamento,
          tiposSepulturas,
          usuariosBaixa,
          contas
        )
      ),
  }
}

class LivroCaixaFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.showPesquisarButton = false
    this.showCSVButton = false
    this.showColumnButton = false
    this.state = {
      dadosFavorito: null,
      favorito: 0,
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_LIVRO_CAIXA}`)
    }
    actions.afterLoadFavorito = (data) => {
      if (data && data.oid) {
        this.setState({ favorito: 1 })
        this.setState({ dadosFavorito: data })
      } else {
        this.setState({ favorito: 0 })
        this.setState({ dadosFavorito: null })
      }
    }
  }

  componentDidMount() {
    logarAcesso().then()
    this.props.newHandler()
    this.props.loadFavorito(this.props.history.location.pathname)
    this.props.carregarTiposSepulturas()
    const currentUnit = storage.getUnit()
    const unidadeCorrente = currentUnit
      ? [
          {
            id: currentUnit.oid,
            value: currentUnit.sigla,
          },
        ]
      : []
    if (this.props.filtraUsuarioBaixa) {
      this.props.carregarUsuariosBaixa(unidadeCorrente)
    }
    this.props.carregarContasCorrentes(unidadeCorrente)
  }

  loadFavorito() {
    listPageUtils.loadFavorito(this, actions)
  }

  changeFavorito() {
    listPageUtils.changeFavorito(this, actions)
  }

  abrirRelatorio = () => {
    let tiposSepulturasSelecionadas = this.props.record.tiposSepulturas
    if (utils.isArrayNullOrEmpty(tiposSepulturasSelecionadas)) {
      tiposSepulturasSelecionadas = []
    } else {
      tiposSepulturasSelecionadas = utils.convertArrayIdLabelToIdValue(tiposSepulturasSelecionadas)
    }
    let usuariosBaixaSelecionadas = this.props.record.usuariosBaixa
    if (utils.isArrayNullOrEmpty(usuariosBaixaSelecionadas)) {
      usuariosBaixaSelecionadas = []
    } else {
      usuariosBaixaSelecionadas = utils.convertArrayIdLabelToIdValue(usuariosBaixaSelecionadas)
    }
    let formaPagamento
    if (this.props.record.tipoFormaPagamento && this.props.record.tipoFormaPagamento.length > 0) {
      formaPagamento = this.props.record.tipoFormaPagamento.map((tipo) => {
        return tipo.id
      })
    } else {
      formaPagamento = this.props.formasPagamento.map((tipo) => {
        return tipo.id
      })
    }

    let contasSelecionadas = this.props.record.contasCorrentes
    if (utils.isArrayNullOrEmpty(contasSelecionadas)) {
      contasSelecionadas = []
    } else {
      contasSelecionadas = utils.convertArrayIdLabelToIdValue(contasSelecionadas)
    }

    const unidades = utils.convertArrayIdLabelToIdValue(this.props.record.unidade)
    this.props.abrirRelatorio(
      this.props.record.dataInicial,
      this.props.record.dataFinal,
      unidades,
      this.props.record.isDetalhado,
      this.props.record.hasTotalizadores,
      formaPagamento,
      tiposSepulturasSelecionadas,
      usuariosBaixaSelecionadas,
      contasSelecionadas
    )
  }

  carregarTiposSepulturas = () => {
    this.props.carregarTiposSepulturas(this.props.record.unidade)
  }

  carregarUsuariosBaixa = () => {
    this.props.carregarUsuariosBaixa(this.props.record.unidade)
  }

  getCustomButtons = () => {
    return (
      <div className="p-toolbar-group-left">
        <Button label="Visualizar" icon="pi pi-check" className="p-button-success" onClick={this.abrirRelatorio} />
        <AgendarTelaFixa path="livrocaixa" record={this.props.record} />
      </div>
    )
  }

  onChangeUnit = (e) => {
    const target = e.target
    const field = target.name
    const valor = target.value
    this.props.setField(field, valor)
    this.props.carregarTiposSepulturas(utils.convertArrayIdLabelToIdValue(valor))
    if (this.props.filtraUsuarioBaixa) {
      this.props.carregarUsuariosBaixa(utils.convertArrayIdLabelToIdValue(valor))
    }
    this.props.carregarContasCorrentes(utils.convertArrayIdLabelToIdValue(valor))
  }

  buildHeader = () => {
    return (
      <div>
        <DefaultToolBar listPageContainer={this} title={nomeRelatorio('livrocaixa')} />
      </div>
    )
  }

  render() {
    const content = (
      <LivroCaixaForm
        abrirRelatorio={this.abrirRelatorio}
        currentUser={this.props.currentUser}
        messages={this.props.messages}
        changeHandler={this.props.changeHandler}
        record={this.props.record}
        disableUnit={this.props.disableUnit}
        unidades={this.props.unidades}
        onChangeUnit={this.onChangeUnit}
        formasPagamento={this.props.formasPagamento}
        filtraUsuarioBaixa={this.props.filtraUsuarioBaixa}
      />
    )

    return <Page content={content} header={this.buildHeader()} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LivroCaixaFormPageContainer)
